var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 324,
    viewBox: "0 0 430 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.131 97.1052L173.131 107.483L130.643 82.8342L149.293 72.4561L191.131 97.1052Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.131 151.92L173.131 162.298L130.643 137.649L149.293 127.271L191.131 151.92Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.028 151.92L173.025 162.298L130.537 137.649L149.187 127.271L191.028 151.92Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.129 107.483V162.298",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.454 72.4561V127.27L130.658 137.629V82.8184",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.129 96.9248V151.739",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.987 127.918L116.984 138.296L74.4961 113.647L93.1464 103.269L134.987 127.918Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.987 182.732L116.984 193.11L74.4961 168.461L93.1464 158.083L134.987 182.732Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.884 182.732L116.885 193.11L74.3965 168.461L93.0468 158.083L134.884 182.732Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.986 138.296V193.11",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3099 103.269V158.083L74.5176 168.442V113.631",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.988 127.737V182.552",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.902 124.515L287.902 134.893L245.414 110.244L264.064 99.8623L305.902 124.515Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.902 179.326L287.902 189.707L245.414 165.055L264.064 154.677L305.902 179.326Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.8 179.326L287.8 189.707L245.309 165.055L263.959 154.677L305.8 179.326Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.9 134.893V189.707",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.224 99.8623V154.677L245.432 165.039V110.225",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.9 124.335V179.146",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.683 155.44L343.683 165.819L301.195 141.169L319.842 130.788L361.683 155.44Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.683 210.252L343.683 220.633L301.195 195.981L319.842 185.603L361.683 210.252Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.581 210.252L343.578 220.633L301.09 195.981L319.74 185.603L361.581 210.252Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.682 165.818V220.633",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.005 130.788V185.602L301.209 195.965V141.15",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.682 155.261V210.072",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.768 87.4412L223.767 97.8193L266.256 73.1701L247.608 62.792L205.768 87.4412Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.768 142.256L223.767 152.634L266.256 127.985L247.608 117.606L205.768 142.256Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.867 142.256L223.87 152.634L266.358 127.985L247.708 117.606L205.867 142.256Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.768 97.8191V152.633",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.445 62.792V117.606L266.241 127.965V73.1512",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.768 87.2607V142.075",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.15 62.7439L184.15 73.122L226.638 48.4728L207.991 38.0947L166.15 62.7439Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15 117.558L184.15 127.936L226.638 103.287L207.991 92.9054L166.15 117.558Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25 117.558L184.253 127.936L226.741 103.287L208.091 92.9053L166.25 117.558Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.15 73.1218V127.936",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.828 38.0947V92.9058L226.624 103.268V48.4539",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15 62.5635V117.378",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.469 231.108L226.472 241.487L268.96 216.837L250.31 206.456L208.469 231.108Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.469 285.92L226.472 296.301L268.96 271.649L250.31 261.271L208.469 285.92Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.574 285.92L226.574 296.301L269.062 271.649L250.415 261.271L208.574 285.92Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.471 241.486V296.301",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 206.456V261.27L268.941 271.633V216.818",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.469 230.929V285.74",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.129 206.522L191.129 216.904L233.617 192.251L214.97 181.873L173.129 206.522Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.129 261.337L191.129 271.715L233.617 247.066L214.97 236.688L173.129 261.337Z",
    stroke: "#231F20",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.229 261.337L191.232 271.715L233.72 247.066L215.069 236.688L173.229 261.337Z",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.129 216.903V271.714",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.807 181.873V236.687L233.602 247.046V192.235",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.129 206.342V261.156",
    stroke: "white",
    strokeWidth: 0.757757,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.99 94.7598L372.202 249.2",
    stroke: "white",
    strokeWidth: 6.07152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.149 230.972L277.945 263.954L142.916 185.617L202.182 152.633L335.149 230.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5918 218.931L147.861 185.946",
    stroke: "white",
    strokeWidth: 6.07152,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.688 174.41C186.848 174.17 186.216 173.993 185.525 173.797C186.823 171.685 188.079 169.632 189.389 167.501C188.72 167.334 188.168 167.195 187.523 167.031C188.736 164.777 189.923 162.57 191.161 160.262C190.406 160.151 189.781 160.059 188.938 159.936C191.625 156.144 193.181 151.904 194.801 147.437C196.487 151.854 197.958 156.135 200.721 159.933C199.875 160.053 199.234 160.145 198.46 160.255C199.698 162.541 200.882 164.732 202.12 167.021C201.51 167.176 200.961 167.315 200.235 167.498C201.539 169.617 202.808 171.682 204.115 173.803C203.402 174.002 202.77 174.176 201.946 174.406C203.597 176.759 205.186 179.019 206.922 181.498H196.525V189.678H193.14V181.558H182.674C184.426 179.06 186.014 176.796 187.688 174.41Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.581 195.039C257.013 194.878 256.587 194.758 256.119 194.626C256.997 193.195 257.846 191.812 258.73 190.369C258.279 190.256 257.903 190.161 257.467 190.054C258.285 188.529 259.09 187.035 259.927 185.476C259.416 185.4 258.996 185.34 258.424 185.255C260.24 182.691 261.294 179.824 262.387 176.806C263.526 179.792 264.521 182.685 266.39 185.255C265.819 185.337 265.383 185.397 264.862 185.472C265.699 187.02 266.497 188.5 267.334 190.047C266.921 190.152 266.551 190.246 266.062 190.369C266.943 191.803 267.801 193.198 268.685 194.632C268.202 194.764 267.776 194.884 267.22 195.039C268.338 196.63 269.408 198.159 270.586 199.832H263.558V205.364H261.269V199.873H254.193C255.377 198.184 256.451 196.653 257.584 195.039H257.581Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.573 234.885C285.005 234.724 284.579 234.604 284.112 234.471C284.989 233.041 285.839 231.658 286.723 230.215C286.271 230.102 285.895 230.007 285.46 229.899C286.277 228.375 287.083 226.881 287.919 225.321C287.408 225.246 286.988 225.186 286.416 225.1C288.232 222.537 289.286 219.67 290.379 216.651C291.519 219.638 292.513 222.53 294.382 225.1C293.811 225.182 293.375 225.242 292.854 225.318C293.691 226.865 294.49 228.346 295.326 229.893C294.913 229.997 294.543 230.092 294.054 230.215C294.935 231.649 295.794 233.044 296.678 234.478C296.195 234.61 295.768 234.73 295.213 234.885C296.33 236.476 297.401 238.004 298.578 239.678H291.55V245.209H289.261V239.719H282.186C283.37 238.03 284.443 236.498 285.577 234.885H285.573Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.514 179.446C174.557 179.174 173.84 178.972 173.054 178.748C174.532 176.342 175.962 174.009 177.452 171.581C176.691 171.388 176.063 171.23 175.327 171.047C176.707 168.48 178.058 165.967 179.47 163.34C178.611 163.214 177.901 163.11 176.938 162.968C179.994 158.648 181.771 153.821 183.612 148.734C185.532 153.764 187.208 158.639 190.353 162.964C189.39 163.1 188.657 163.204 187.78 163.331C189.188 165.935 190.536 168.43 191.944 171.035C191.25 171.211 190.625 171.369 189.797 171.578C191.281 173.99 192.727 176.339 194.214 178.757C193.403 178.982 192.683 179.184 191.745 179.442C193.624 182.123 195.433 184.696 197.413 187.516H185.573V196.83H181.718V187.582H169.799C171.794 184.737 173.603 182.158 175.51 179.442L175.514 179.446Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.486 182.372C239.53 182.101 238.813 181.899 238.027 181.675C239.504 179.269 240.935 176.935 242.425 174.507C241.664 174.315 241.036 174.157 240.3 173.974C241.68 171.407 243.031 168.894 244.442 166.267C243.584 166.141 242.873 166.036 241.91 165.894C244.966 161.575 246.744 156.748 248.585 151.661C250.504 156.691 252.181 161.566 255.326 165.891C254.363 166.027 253.63 166.131 252.752 166.257C254.161 168.862 255.509 171.356 256.917 173.961C256.222 174.138 255.597 174.296 254.77 174.504C256.254 176.917 257.7 179.266 259.187 181.684C258.376 181.908 257.656 182.11 256.718 182.369C258.597 185.05 260.406 187.623 262.385 190.442H250.545V199.757H246.69V190.509H234.771C236.767 187.664 238.576 185.085 240.483 182.369L240.486 182.372Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.572 243.35C269.616 243.078 268.899 242.876 268.113 242.652C269.59 240.246 271.021 237.913 272.511 235.485C271.75 235.292 271.122 235.135 270.386 234.951C271.766 232.385 273.117 229.871 274.528 227.244C273.67 227.118 272.959 227.014 271.996 226.872C275.052 222.553 276.83 217.725 278.671 212.639C280.59 217.668 282.267 222.543 285.412 226.869C284.449 227.004 283.716 227.109 282.838 227.235C284.247 229.84 285.595 232.334 287.003 234.939C286.308 235.116 285.683 235.273 284.856 235.482C286.34 237.894 287.786 240.243 289.273 242.662C288.462 242.886 287.742 243.088 286.804 243.347C288.683 246.027 290.492 248.601 292.471 251.42H280.631V260.734H276.776V251.486H264.857C266.853 248.642 268.662 246.062 270.569 243.347L270.572 243.35Z",
    fill: "white",
    stroke: "#726659",
    strokeWidth: 1.51867,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.304 75.1749L149.9 31.3545L54 90.8731L158.896 152.084",
    stroke: "#F69320",
    strokeWidth: 4.55285,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.932 113.079L375.61 167.963L278.604 216.282L273.329 219.102L219.859 187.898",
    stroke: "#F69320",
    strokeWidth: 4.55285,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.599 78.6348C200.857 78.6348 212.416 67.076 212.416 52.8174C212.416 38.5588 200.857 27 186.599 27C172.34 27 160.781 38.5588 160.781 52.8174C160.781 67.076 172.34 78.6348 186.599 78.6348Z",
    fill: "#F69320"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285.027 128.783L284.787 112.642L301.208 111.411",
    stroke: "#F69320",
    strokeWidth: 4.55285,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.149 138.17L161.788 153.631L146.326 159.299",
    stroke: "#F69320",
    strokeWidth: 4.55285,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.80a85914c08a6548cbfd66ceb7e318b2.svg";
export { ForwardRef as ReactComponent };